export var DebitCardValidationResultType;
(function (DebitCardValidationResultType) {
    DebitCardValidationResultType["SUCCESS"] = "success";
    DebitCardValidationResultType["FAIL"] = "fail";
    DebitCardValidationResultType["THIRD_PARTY_EXCEPTION"] = "third_party_exception";
    DebitCardValidationResultType["SYSTEM_EXCEPTION"] = "system_exception";
})(DebitCardValidationResultType || (DebitCardValidationResultType = {}));
//# sourceMappingURL=DebitCardValidationResultType.js.map